import { withAuth } from '@okta/okta-react';
import intersection from 'lodash/intersection';
import React from 'react';

export const check = (allowedRoles, props) => {
  /* istanbul ignore next */
  if (!props.auth._oktaAuth.tokenManager.get('idToken')) return false;
  const { groups } = props.auth._oktaAuth.tokenManager.get('idToken').claims;
  const granted = groups && intersection(groups, allowedRoles).length > 0;
  // console.log('check: (%s) intersects (%s) = %s', groups, allowedRoles, granted);
  return granted;
};

export const HasTokenOrNull = Component => (
  withAuth(props => (
    props.auth._oktaAuth.tokenManager.get('idToken')
      ? <Component {...props} />
      : null
  ))
);

export const withRole = allowedRoles =>
  WrappedComponent =>
    withAuth(props => (
      check(allowedRoles, props) ?
        <WrappedComponent {...props} /> :
        <h1>Access Denied</h1>
    ));

export const HasRole = allowedRoles =>
  withAuth(props => (
    check(allowedRoles, props) ?
      props.children :
      null
  ));

const withEither = allowedRoles =>
  (Component, ElseComponent) =>
    withAuth(props => (
      check(allowedRoles, props)
        ? <Component {...props} />
        : <ElseComponent {...props} />
    ));

export function checkIfFullAccess() {
  const allowedRoles = ['WAP-FULL', 'WAP-FULL-NOAUTORENEW'];
  const oktaToken = window.sessionStorage.getItem('okta-token-storage');
  if (oktaToken === null) return false;
  const { groups } = JSON.parse(oktaToken).idToken.claims;
  const granted = groups && intersection(groups, allowedRoles).length > 0;
  return granted;
}

export const withWapVerifyLevel = withRole(['WAP-FULL', 'WAP-FULL-NOAUTORENEW', 'WAP-UPDATE', 'WAP-VERIFY']);
export const withWapUpdateLevel = withRole(['WAP-FULL', 'WAP-FULL-NOAUTORENEW', 'WAP-UPDATE']);
export const withWapFullLevel = withRole(['WAP-FULL', 'WAP-FULL-NOAUTORENEW']);
export const withWapUserAdminLevel = withRole(['WAP-USERADMIN']);

export const HasWapUpdateLevel = HasRole(['WAP-FULL', 'WAP-UPDATE', 'WAP-FULL-NOAUTORENEW']);
export const HasWapFullLevel = HasRole(['WAP-FULL', 'WAP-FULL-NOAUTORENEW']);
export const HasAutoRenewLevel = HasRole(['WAP-FULL']);

export const HasWapFullRole = HasRole(['WAP-FULL', 'WAP-FULL-NOAUTORENEW']);
export const HasWapUpdateRole = HasRole(['WAP-UPDATE']);
export const HasWapUserAdminRole = HasRole(['WAP-USERADMIN']);

export const HasWapFullElseUpdateRole = withEither(['WAP-FULL', 'WAP-FULL-NOAUTORENEW']);



// WEBPACK FOOTER //
// ./src/app/containers/Authorization/index.js